<div *ngIf="showAdminPanel()" class="admin-panel">
    <eil-generic-modal></eil-generic-modal>
    <eil-text-input-modal></eil-text-input-modal>
    <h4 class="account-details-header">
        User Administration
    </h4>

    <div class="row user-admin-property-row">
        <div class="col-4 user-admin-property-label-div">
            <span class="user-admin-property-label">
                Is PD Member:
            </span>
        </div>
        <div class="col-2 user-admin-property-value-div">
            <span [ngClass]="{'bold': !user.isMember}" class="user-admin-property-value">
                {{ user.isMember ? "Yes" : "No" }}
            </span>
        </div>
        <div class="col-4 user-admin-property-actions-div">
            <button (click)="toggleIsMember(user, true)" *ngIf="memberLogic.adminCanMakeMember(user)"
                    class="btn btn-secondary"
                    type="button">
                Set as Member
            </button>
            <button (click)="toggleIsMember(user, false)" *ngIf="memberLogic.adminCanRemoveAsMember(user)"
                    class="btn btn-secondary"
                    type="button">
                Remove as Member
            </button>
        </div>
    </div>

    <div class="row user-admin-property-row">
        <div class="col-4 user-admin-property-label-div">
            <span class="user-admin-property-label">
                PD Member Registration Complete:
            </span>
        </div>
        <div class="col-2 user-admin-property-value-div">
            <span [ngClass]="{'bold': !user.isRegistered}" class="user-admin-property-value">
                {{ user.isRegistered ? "Yes" : "No" }}
            </span>
        </div>
    </div>

    <div class="row user-admin-property-row">
        <div class="col-4 user-admin-property-label-div">
            <span class="user-admin-property-label">
                Approval Status:
            </span>
        </div>
        <div class="col-2 user-admin-property-value-div">
            <span class="user-admin-property-value">
                {{ user.isApproved ? "Approved" : (user.hasBeenApproved ? "Deactivated" : "Pending") }}
            </span>
        </div>
        <div class="col-4 user-admin-property-actions-div">
            <button (click)="toggleIsApproved(user, true)" *ngIf="memberLogic.adminCanApprove(user)"
                    class="btn btn-primary"
                    type="button">
                Approve
            </button>
            <button (click)="reject(user)" *ngIf="memberLogic.adminCanReject(user)" class="btn btn-danger"
                    type="button">
                Reject
            </button>
            <button (click)="deactivate(user)" *ngIf="memberLogic.adminCanDeactivate(user)" class="btn btn-secondary"
                    type="button">
                Deactivate
            </button>
            <button (click)="reactivate(user)" *ngIf="memberLogic.adminCanReactivate(user)" class="btn btn-secondary"
                    type="button">
                Reactivate
            </button>
        </div>
    </div>

    <div class="row user-admin-property-row">
        <div class="col-4 user-admin-property-label-div">
            <span class="user-admin-property-label">
                Is Administrator:
            </span>
        </div>
        <div class="col-2 user-admin-property-value-div">
            <span [ngClass]="{'bold': user.isAdmin}" class="user-admin-property-value">
                {{ user.isAdmin ? "Yes" : "No" }}
            </span>
        </div>
        <div class="col-4 user-admin-property-actions-div">
            <button (click)="toggleIsAdmin(user, true)" *ngIf="memberLogic.adminCanMakeAdmin(user)"
                    class="btn btn-secondary"
                    type="button">
                Make Admin
            </button>
            <button (click)="toggleIsAdmin(user, false)" *ngIf="memberLogic.adminCanRemoveAsAdmin(user)"
                    class="btn btn-secondary"
                    type="button">
                Remove as Admin
            </button>
        </div>
    </div>
</div>

<div *ngIf="user && user.id && user.hasBeenApproved && !user.isAuditor" class="credit-balance-div">
    <h4>Credit Balance History</h4>
    <div class="credit-balance-explanation">
        PD Applications go through several stages of affecting remaining credits:
        <ol>
            <li>
                When the application is first submitted with anticipated expenses, but has not yet been approved
                ("<b><i>Requested</i></b>")
            </li>
            <li>
                The application has been approved with anticipated expenses, but not yet with actual expenses ("<b><i>Pending</i></b>")
            </li>
            <li>
                Actual expenses have been approved ("<b><i>Actual</i></b>")
            </li>
        </ol>
        This credit balance chart shows 3 remaining balance columns. Each of these only include the cost of applications
        that have gone at least as far
        as that stage.<br/>
        For example, a $70 application that has reached the "Pending" stage will result in that $70 being subtracted
        from the "Requested"
        and "Pending" balances, but not from the "Actual" balance. <br/>
        Note: For the purposes of the credits available display bar, and the credits exceeded warnings when submitting
        an application, the system uses the
        "Pending" balance type.
    </div>
    <div *ngIf="showAdminPanel()" class="add-credits-div">
        Add credits:
        <input [(ngModel)]="creditsToAdd" [step]="0.01" id="startingBalance"
               name="startingBalance"
               type="number"/>
        <button (click)="addCredits(creditsToAdd)" [disabled]="!creditsToAdd" class="btn btn-secondary" type="button">
            Add
        </button>
    </div>
    <table class="full-collapse-horizontal-table credit-balance-table">
        <thead>
        <tr>
            <th>
                Date
            </th>
            <th>
                Label
            </th>
            <th class="amount-header">
                Amount
            </th>
            <th>
                Status
            </th>
            <th class="balances-header">
                Effective Balance:
            </th>
            <th class="subheader requested-header">
                Requested
            </th>
            <th class="subheader pending-header">
                Pending
            </th>
            <th class="subheader spent-header">
                Actual
            </th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let row of user.ledger">
            <td>
                {{ getDisplayDate(row.date) }}
            </td>
            <td>
                {{ row.label }}
            </td>
            <td class="amount-cell">
                {{ row.amount | currency:'CAD':'symbol-narrow':'1.2-2' }}
            </td>
            <td>
                {{ row.status }}
            </td>
            <td></td>
            <td class="requested-cell">
                {{ row.newProposedBalance | currency:'CAD':'symbol-narrow':'1.2-2' }}
            </td>
            <td class="pending-cell">
                {{ row.newPendingBalance | currency:'CAD':'symbol-narrow':'1.2-2' }}
            </td>
            <td class="spent-cell">
                {{ row.newSpentBalance | currency:'CAD':'symbol-narrow':'1.2-2' }}
            </td>
        </tr>
        <tr *ngIf="!user.ledger || !user.ledger.length">
            <td colspan="8">
                No credits or applications yet.
            </td>
        </tr>
        </tbody>
    </table>
</div>

<div *ngIf="user && user.id && user.hasBeenApproved && user.isAuditor" class="credit-balance-div">
    <h4>Auditor cannot alter their account</h4>
</div>

<div *ngIf="user && user.id && user.hasBeenApproved && (!user.isAuditor || showAdminPanel())" class="subscription-div">
    <span *ngIf="waiting" class="app-loading">
        <svg class="spinner" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10" stroke-width="2"/>
        </svg>
    </span>
    <div *ngIf="!waiting">
        <h4 class="subscription-header">
            Email from Elk Island Local #28
        </h4>
        Currently {{ user.isSubscribed ? '' : 'NOT' }} subscribed to EIL mailings.
        <button (click)="unsubscribe(user)" *ngIf="user.isSubscribed" class="btn btn-secondary" type="button">
            Unsubscribe
        </button>
        <button (click)="resubscribe(user)" *ngIf="!user.isSubscribed" class="btn btn-secondary" type="button">
            Re-subscribe
        </button>
    </div>
</div>

<form #pdAccountDetailsForm="ngForm" (ngSubmit)="onSave()" *ngIf="!user.isAuditor" class="page-form">
    <span *ngIf="waiting" class="app-loading">
        <svg class="spinner" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" fill="none" r="20" stroke-miterlimit="10" stroke-width="2"/>
        </svg>
    </span>
    <div *ngIf="!waiting" class="account-details">
        <h4 class="account-details-header">
            Account Details
        </h4>
        <div class="lined-input-group">
            <label for="firstName">
                First Name
            </label>
            <input #firstName="ngModel" [(ngModel)]="user.firstName" class="form-control" id="firstName"
                   name="firstName" required
                   type="text"/>
            <div *ngIf="firstName.invalid"
                 class="alert alert-danger">

                <div *ngIf="firstName.errors.required">
                    First Name is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="lastName">
                Last Name
            </label>
            <input #lastName="ngModel" [(ngModel)]="user.lastName" class="form-control" id="lastName" name="lastName"
                   required
                   type="text"/>
            <div *ngIf="lastName.invalid"
                 class="alert alert-danger">

                <div *ngIf="lastName.errors.required">
                    Last Name is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="employmentType">
                Employment Type
            </label>
            <select #employmentType="ngModel" [(ngModel)]="user.employmentType" class="form-select form-control"
                    id="employmentType"
                    name="employmentType" required>
                <option value="Permanent">Permanent</option>
                <option value="Temporary">Temporary</option>
                <option value="Substitute">Substitute</option>
            </select>
            <div *ngIf="employmentType.invalid"
                 class="alert alert-danger">

                <div *ngIf="employmentType.errors.required">
                    Employment Type is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label>
                Login Email
            </label>
            <div class="d-flex">
                <input #email="ngModel" [(ngModel)]="user.email" [pattern]="emailRegex"
                       class="form-control form-control-plaintext" disabled
                       id="email" name="email"
                       type="text"/>
                <button (click)="showEmailChangeModal(user)" *ngIf="currentUser.isAdmin"
                        class="btn btn-primary text-nowrap"
                        type="button">
                    Change Email
                </button>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="email">
                Preferred Email
            </label>
            <input #preferredEmail="ngModel" [(ngModel)]="user.preferredEmail" class="form-control" id="preferredEmail"
                   name="preferredEmail"
                   required type="text"/>
            <div *ngIf="preferredEmail.invalid"
                 class="alert alert-danger">

                <div *ngIf="preferredEmail.errors.required">
                    Preferred Email is required.
                </div>
                <div *ngIf="preferredEmail.errors.pattern">
                    Preferred Email must be a valid email address.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="teachingCertNo">
                Teaching Certificate Number
            </label>
            <input #teachingCertNo="ngModel" [(ngModel)]="user.teachingCertNo" class="form-control" id="teachingCertNo"
                   name="teachingCertNo"
                   required type="text"/>
            <div *ngIf="teachingCertNo.invalid"
                 class="alert alert-danger">

                <div *ngIf="teachingCertNo.errors.required">
                    Teaching Certificate Number is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="address1">
                Address line 1
            </label>
            <input #address="ngModel" [(ngModel)]="user.addressLine1" class="form-control" id="address" name="address"
                   required
                   type="text"/>
            <div *ngIf="address.invalid"
                 class="alert alert-danger">

                <div *ngIf="address.errors.required">
                    Address is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="address2">
                Address line 2
            </label>
            <input #address2="ngModel" [(ngModel)]="user.addressLine2" class="form-control" id="address2"
                   name="address2"
                   type="text"/>
        </div>
        <div class="lined-input-group">
            <label for="city">
                City
            </label>
            <input #city="ngModel" [(ngModel)]="user.city" class="form-control" id="city" name="city" required
                   type="text"/>
            <div *ngIf="city.invalid"
                 class="alert alert-danger">

                <div *ngIf="city.errors.required">
                    City is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="postalCode">
                Postal Code
            </label>
            <input #postalCode="ngModel" [(ngModel)]="user.postalCode" [pattern]="postalCodeRegex" class="form-control"
                   id="postalCode" name="postalCode"
                   required
                   type="text"/>
            <div *ngIf="postalCode.invalid"
                 class="alert alert-danger">

                <div *ngIf="postalCode.errors.required">
                    Postal Code is required.
                </div>
                <div *ngIf="postalCode.errors.pattern">
                    Postal Code must be valid.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="homePhone">
                Home Phone
            </label>
            <input #homePhone="ngModel" [(ngModel)]="user.homePhone" [pattern]="phoneNumberRegex" class="form-control"
                   id="homePhone" name="homePhone"
                   required
                   type="text"/>
            <div *ngIf="homePhone.invalid"
                 class="alert alert-danger">

                <div *ngIf="homePhone.errors.required">
                    Home Phone is required.
                </div>
                <div *ngIf="homePhone.errors.pattern">
                    Home Phone must be a valid phone number.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="schoolName">
                School
            </label>
            <input #schoolName="ngModel" [(ngModel)]="user.schoolName" class="form-control" id="schoolName"
                   name="schoolName" pattern=".{3,}"
                   required
                   type="text"/>
            <div *ngIf="schoolName.invalid"
                 class="alert alert-danger">

                <div *ngIf="schoolName.errors.required">
                    School is required.
                </div>
                <div *ngIf="schoolName.errors.pattern">
                    School cannot be less than 3 letters.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="schoolPhone">
                School Phone
            </label>
            <input #schoolPhone="ngModel" [(ngModel)]="user.schoolPhone" [pattern]="phoneNumberRegex"
                   class="form-control" id="schoolPhone" name="schoolPhone"
                   required
                   type="text"/>
            <div *ngIf="schoolPhone.invalid"
                 class="alert alert-danger">

                <div *ngIf="schoolPhone.errors.required">
                    School Phone is required.
                </div>
                <div *ngIf="schoolPhone.errors.pattern">
                    School Phone must be a valid phone number.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="grades">
                Grade(s)
            </label>
            <input #grades="ngModel" [(ngModel)]="user.grades" class="form-control" id="grades" name="grades" required
                   type="text"/>
            <div *ngIf="grades.invalid"
                 class="alert alert-danger">

                <div *ngIf="grades.errors.required">
                    Grade(s) is required.
                </div>
            </div>
        </div>
        <div class="lined-input-group">
            <label for="subject">
                Subject(s)
            </label>
            <input #subject="ngModel" [(ngModel)]="user.subject" class="form-control" id="subject" name="subject"
                   required
                   type="text"/>
            <div *ngIf="subject.invalid"
                 class="alert alert-danger">

                <div *ngIf="subject.errors.required">
                    Subject(s) is required.
                </div>
            </div>
        </div>

        <div class="submit-button-div">
            <button [disabled]="waiting || !pdAccountDetailsForm.form.valid" [ngClass]="{'working': waiting}"
                    class="btn btn-primary"
                    type="submit">Save
            </button>
            <div *ngIf="!waiting && !pdAccountDetailsForm.form.valid"
                 class="alert alert-danger">
                There are errors in the information entered above.
            </div>
        </div>
    </div>
</form>
